export default function Waveform({ bars = 5 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3, height: 22 }}>
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          style={{
            width: 3,
            borderRadius: 2,
            background: "rgba(255,255,255,0.85)",
            animation: `wave 0.7s ease ${i * 0.1}s infinite`,
            transformOrigin: "bottom",
          }}
        />
      ))}
    </div>
  );
}
